import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as classes from './Title.module.css';

const Title = ({
  title,
  content = '',
  center = false,
  primary = false,
  subtitle = false,
  callToAction = false,
  primarySubtitle = false,
  movingTitle,
  finnishLanguage = false,
}) => {
  const [movingIndex, setMovingIndex] = useState(0);
  const movingParts =
    movingTitle &&
    movingTitle.references.filter((item) => {
      return item.internal.type === 'ContentfulMovingContent';
    });
  const movingLength = movingTitle && movingParts.length;
  const [letterIndex, setLetterIndex] = useState(0);
  const [reverse, setReverse] = useState(false);

  useEffect(() => {
    const titles = document.querySelectorAll('.title');
    for (let i = 0; i < titles.length; i++) {
      const node = titles[i];
      if (node.scrollWidth > node.clientWidth) {
        const computedStyle = window.getComputedStyle(node);
        const currentSize = parseFloat(
          computedStyle.getPropertyValue('font-size').slice(0, -2)
        );

        node.style.fontSize = `${currentSize - 4}px`;
      }
    }

    if (movingTitle) {
      if (
        letterIndex === movingParts[movingIndex].movingTitle.length + 1 &&
        !reverse
      ) {
        setReverse(true);
        return;
      }

      if (letterIndex === 0 && reverse) {
        setReverse(false);
        if (movingIndex === movingLength - 1) {
          setMovingIndex(0);
        } else {
          setMovingIndex(movingIndex + 1);
        }

        return;
      }

      const titleInterval = setInterval(
        () => {
          setLetterIndex(letterIndex + (reverse ? -1 : 1));
        },
        letterIndex === movingParts[movingIndex].movingTitle.length + 1
          ? 2000
          : 100
      );

      return () => clearInterval(titleInterval);
    }
  }, [
    movingTitle,
    movingIndex,
    movingLength,
    letterIndex,
    movingParts,
    reverse,
  ]);

  return movingTitle ? (
    <section className={`${classes.moving} ${center ? 'centered' : ''}`}>
      <div className={classes.titleArea}>
        <h1 className={`${finnishLanguage ? classes.finnishNewsletter : ''}`}>
          {title}
        </h1>
        <span className={`${finnishLanguage ? classes.finnishNewsletter : ''}`}>
          {movingParts[movingIndex].movingTitle.substring(0, letterIndex)}
        </span>
      </div>
      {content && <h4 className={`${center ? 'centered' : ''}`}>{content}</h4>}
    </section>
  ) : (
    <section
      className={`${center ? 'centered' : ''} ${
        primary ? classes.primary : ''
      } ${callToAction ? classes.callToAction : ''}`}
    >
      <h1 className={`title ${subtitle ? classes.subtitle : ''}`}>{title}</h1>
      {content && (
        <p
          className={`title ${center ? 'centered' : ''} ${
            primary || primarySubtitle ? classes.primary : ''
          } ${callToAction ? classes.subheadline : ''}`}
        >
          {content}
        </p>
      )}
    </section>
  );
};

Title.propTypes = {
  title: PropTypes.string,
  content: PropTypes.string,
  center: PropTypes.bool,
  primary: PropTypes.bool,
  subtitle: PropTypes.bool,
  callToAction: PropTypes.bool,
  primarySubtitle: PropTypes.bool,
  movingTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  finnishLanguage: PropTypes.bool,
};

export default Title;
